import {Action} from "redux";
import {IClientMypageActionCreator} from "../action/client_mypage_action";
import {
    UpdatePasswordByClientRequest,
    UpdateCompanyByClientRequest,
    UpdateClientByClientRequest,
    UpdateEmailByClientRequest,
} from "../request/mypage_request";

interface IClientMypageDispatcher {
    getMeClient(): void;

    updateCompany(
        item: UpdateCompanyByClientRequest,
    ): void;

    updateClient(
        item: UpdateClientByClientRequest,
    ): void

    updatePassword(
        item: UpdatePasswordByClientRequest,
    ): void;

    updateEmail(
        item: UpdateEmailByClientRequest,
    ): void;

}

class Dispatcher implements IClientMypageDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientMypageActionCreator) {

    }

    public getMeClient = (): void => {
        this.dispatch(this.actionCreator.requestGetMeClientAction());
    };

    public updateCompany = (
        item: UpdateCompanyByClientRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestUpdateCompanyAction(
            item,
        ))
    };

    public updateClient = (
        item: UpdateClientByClientRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestUpdateClientAction(
            item,
        ));
    };

    public updatePassword = (
        item: UpdatePasswordByClientRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestUpdatePasswordAction(
            item,
        ));
    };

    public updateEmail = (
        item: UpdateEmailByClientRequest,
    ): void => {
        this.dispatch(this.actionCreator.requestUpdateEmailAction(
            item,
        ));
    };

}

const createClientMypageDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientMypageActionCreator): IClientMypageDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientMypageDispatcher, createClientMypageDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_mypage_dispatcher.ts